/**
 * @desc 分页
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(params: API.crawler.crawler.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/crawler/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
